import api from '@/api/cashPointsManagement'

const state = {

}

const actions = {
  getCompanyReferralCashBalanceInfo (context, params) {
    return api.getCompanyReferralCashBalanceInfo(params)
  },
  getCompanyReferralPointsBalanceInfo (context, params) {
    return api.getCompanyReferralPointsBalanceInfo(params)
  },
  getClientAdminReferralCashBalance (context, params) {
    return api.getClientAdminReferralCashBalance(params)
  },
  getClientAdminReferralPointsBalance (context, params) {
    return api.getClientAdminReferralPointsBalance(params)
  },
  getCompanyRechargeList (context, params) {
    return api.getCompanyRechargeList(params)
  },
  getClientAdminRechargeList (context, params) {
    return api.getClientAdminRechargeList(params)
  },
  updateCompanyRecharge (context, params) {
    return api.updateCompanyRecharge(params)
  },
  updateClientAdminRecharge (context, params) {
    return api.updateClientAdminRecharge(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
